import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";

import { SPREAD_MAINTENANCE, MAKE_WHOLE, DEFEASANCE, YIELD_MAINTENANCE_TRADITIONAL, YIELD_MAINTENANCE_AGENCY_STYLE } from "../Constants/PrepaymentType";

import { CalculatedInteger } from "./CalculatedValues";
import ReplacementRate from "./ReplacementRate";

const PeriodsRemainingUntilOpen = ({ value }) => <CalculatedInteger label="Periods remaining until open " value={value} min={0} />;

const ImmediateResults = ({ values, periodsRemainingUntilOpen }) => {
  if (!values.prepaymentType) {
    return null;
  }

  return (
    <>
      {
        (values.prepaymentType === SPREAD_MAINTENANCE ||
                        values.prepaymentType === YIELD_MAINTENANCE_TRADITIONAL ||
                        values.prepaymentType === YIELD_MAINTENANCE_AGENCY_STYLE ||
                        values.prepaymentType === DEFEASANCE ||
                        values.prepaymentType === MAKE_WHOLE) &&
                    (<Grid container item xs={12} sm={12} md={12} lg={12} xl={12}><PeriodsRemainingUntilOpen value={periodsRemainingUntilOpen} /></Grid>)
      }
      {
        (values.prepaymentType === YIELD_MAINTENANCE_TRADITIONAL ||
                        values.prepaymentType === YIELD_MAINTENANCE_AGENCY_STYLE ||
                        values.prepaymentType === MAKE_WHOLE) &&
                    (<Grid container item xs={12} sm={12} md={12} lg={12} xl={12}><ReplacementRate periodsRemainingUntilOpen={periodsRemainingUntilOpen} /></Grid>)
      }
    </>
  );
};
export default ImmediateResults;
